import { axiosClient } from '@/libs/axios-client';

const BASE = '/email-templates';

/** Tokens an email template may use: [{ token, group }]. */
export const getEmailTemplateTokens = async () => {
  const { data } = await axiosClient.get(`${BASE}/tokens`);
  return data;
};

/** A company's email templates: { count, items }. */
export const getEmailTemplates = async (company, includeArchived = false) => {
  const { data } = await axiosClient.get(BASE, {
    params: { company, includeArchived: includeArchived ? 'true' : undefined },
  });
  return data;
};

export const createEmailTemplate = async (payload) => {
  const { data } = await axiosClient.post(BASE, payload);
  return data;
};

export const updateEmailTemplate = async (id, payload) => {
  const { data } = await axiosClient.put(`${BASE}/${id}`, payload);
  return data;
};

export const archiveEmailTemplate = async (id) => {
  const { data } = await axiosClient.post(`${BASE}/${id}/archive`);
  return data;
};

export const restoreEmailTemplate = async (id) => {
  const { data } = await axiosClient.post(`${BASE}/${id}/restore`);
  return data;
};

/** Templates offered for an employee and the sends so far. */
export const getEmployeeNotificationState = async (employeeId, event) => {
  const { data } = await axiosClient.get(`${BASE}/employee/${employeeId}`, {
    params: { event },
  });
  return data;
};

/**
 * The complete email (HLB frame included) for template fields as they stand
 * in the editor, filled for a sample employee of the company:
 * { subject, html, hasPhoto, sampleEmployee: { _id, name } }.
 */
export const previewEmailTemplateDraft = async ({ company, subject, bodyHtml, language }) => {
  const { data } = await axiosClient.post(`${BASE}/preview`, {
    company,
    subject,
    bodyHtml,
    language,
  });
  return data;
};

/**
 * The filled email (complete `html`) and its recipients, each marked
 * `visible` (CC) or not (BCC), before sending.
 */
export const previewEmployeeNotification = async (
  employeeId,
  templateId,
  extraMessage = '',
  includeAllEmployees = false,
  includeAllVisible = false
) => {
  const { data } = await axiosClient.post(`${BASE}/employee/${employeeId}/preview`, {
    templateId,
    extraMessage,
    includeAllEmployees,
    includeAllVisible,
  });
  return data;
};

/**
 * People of the employee's company matching `q` (name or email), to add to a
 * notice by hand: { query, items: [{ name, email, kind: 'hr' | 'employee' }] }.
 */
export const searchNoticePeople = async (employeeId, q, signal) => {
  const { data } = await axiosClient.get(`${BASE}/employee/${employeeId}/people`, {
    params: { q },
    signal,
  });
  return data;
};

/**
 * Sends the notice. `extras` (optional, this send only): { extraMessage,
 * excluded: [email], extraCc: [email], extraBcc: [email],
 * includeAllEmployees: boolean, includeAllVisible: boolean }.
 */
export const sendEmployeeNotification = async (employeeId, templateId, extras = {}) => {
  const { data } = await axiosClient.post(`${BASE}/employee/${employeeId}/send`, {
    templateId,
    ...extras,
  });
  return data;
};
